var app = globalThis;
globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};

appCustomerSpace.ModalAddSpecificThematics = (function(superClass) {
  utils.extend(ModalAddSpecificThematics, superClass);

  function ModalAddSpecificThematics() {
    return ModalAddSpecificThematics.__super__.constructor.apply(this, arguments);
  }

  ModalAddSpecificThematics.prototype.init = function() {
    this._addNewSpecificThematic();
    return ModalAddSpecificThematics.__super__.init.apply(this, arguments);
  };

  ModalAddSpecificThematics.prototype.callbackSuccess = function(data, successMsg) {
    var $container = $('.library-items-list-selected:visible');

    if($container.length) {
      $container.find('.no-options').hide();
      $container.prepend(data.html);
    } else {
      $container = $(this.$html.data('target'));
      $container.prepend(data.html);
      appCustomerSpace.creationForm.currentStep.handleItemArrows($container);

      appCustomerSpace.LimitlessPlugins.initPlugins($container);

      $('body').trigger('job_form.change', [$container.parent()]);
    }

    return ModalAddSpecificThematics.__super__.callbackSuccess.call(this, data);
  };

  ModalAddSpecificThematics.prototype._addNewSpecificThematic = function() {
    var self = this;
    this.$html.on('click', '.add-new-specific-thematic', function() {
      var $formGroup;
      $formGroup = self.$html.find('.form-group');
      return $formGroup.find('.input-group:first').clone().appendTo($formGroup).find('input').val('').focus();
    });
    return this.$html.on('click', '.remove-specific-thematic', function() {
      return $(this).closest('.input-group').remove();
    });
  };

  return ModalAddSpecificThematics;

})(appCustomerSpace.Modal);
